import { createSlice } from '@reduxjs/toolkit'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'
import { setLoader } from 'src/redux/loader'

const initialState = {
    results: [],
    page: 1,
    limit: 20,
    totalPages: 0,
    totalResults: 0,
}

const teamsPaginatedSlice = createSlice({
    name: "teamsPaginated",
    initialState,
    reducers: {
        setPaginated: (state, action) => {
            return { ...state, ...action.payload }
        }
    }
})

export const { setPaginated } = teamsPaginatedSlice.actions

export const getTeamsPaginated = (params = {}) => {
    return async (dispatch) => {
        try {
            dispatch(setLoader(true))
            const query = new URLSearchParams(
                Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
            ).toString()
            let res = await hit("/admins/teams/paginated" + (query ? "?" + query : ""), "get")
            if (!res?.err) {
                dispatch(setPaginated(res.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load teams", severity: "error" }))
            }
        } catch (err) {
            dispatch(setToast({ show: true, message: "Failed to load teams", severity: "error" }))
        } finally {
            dispatch(setLoader(false))
        }
    }
}

export default teamsPaginatedSlice.reducer
